
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"67","height":"64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#0a294a","stroke-miterlimit":"20","stroke-width":"3","d":"M33.42 2v0l25.348 11.992v0l6.26 26.945v0l-17.54 21.608v0H19.353v0L1.813 40.937v0l6.26-26.945v0z"}}),_c('path',{attrs:{"fill":"#0a294a","d":"M33.18 27.082c3.74 0 6.785 2.984 6.785 6.648 0 3.664-3.045 6.648-6.784 6.648-3.74 0-6.784-2.984-6.784-6.648 0-3.664 3.045-6.648 6.784-6.648zm.006-2.954c-5.409 0-9.807 4.306-9.807 9.602s4.398 9.602 9.807 9.602c5.408 0 9.806-4.306 9.806-9.602s-4.398-9.602-9.806-9.602zm0-1.478a11.38 11.38 0 019.565 5.17h3.259v14.774c0 2.038-1.69 3.693-3.772 3.693H24.134c-2.082 0-3.772-1.655-3.772-3.693V27.82h3.259a11.376 11.376 0 019.565-5.17zm9.806-1.477h2.263a.75.75 0 01.755.74v2.223a.75.75 0 01-.755.74h-2.263a.75.75 0 01-.754-.74v-2.222c0-.408.34-.74.754-.74zM23.38 17.48c-3.741 0-6.789 2.984-6.789 6.648v19.204c0 3.664 3.048 6.648 6.79 6.648h19.612c3.742 0 6.79-2.984 6.79-6.648V24.128c0-3.664-3.048-6.648-6.79-6.648z"}})])
          )
        }
      }
    